import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CompanyInfoSection from './components/CompanyInfoSection';
import ServicesSection from './components/ServicesSection';
import PatientGuideSection from './components/PatientGuideSection';
import FacilitiesSection from './components/FacilitiesSection';
import CTASection from '../home/components/CTASection';
import { updatePageSEO } from '../../utils/seo';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    updatePageSEO({
      title: '当院について | おかやま整形外科 - 岡山市北区の整形外科クリニック',
      description: 'おかやま整形外科の診療内容、施設案内、受診される方へのご案内。スポーツ障害、関節痛、腰痛、骨折治療など幅広い整形外科診療を提供。最新の医療機器を完備し、地域の皆様の健康をサポートします。',
      keywords: '当院について, 診療内容, 施設案内, 整形外科 岡山, 岡山市北区 クリニック',
      canonical: `${siteUrl}/about`,
      structuredData: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '当院について',
        description: 'おかやま整形外科の診療内容、施設案内、受診される方へのご案内',
        url: `${siteUrl}/about`,
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'ホーム',
              item: `${siteUrl}/`
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: '当院について',
              item: `${siteUrl}/about`
            }
          ]
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <PatientGuideSection />
        <FacilitiesSection />
        <CompanyInfoSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
